import { render, staticRenderFns } from "./pretopup.vue?vue&type=template&id=225562d3&scoped=true&"
import script from "./pretopup.vue?vue&type=script&lang=js&"
export * from "./pretopup.vue?vue&type=script&lang=js&"
import style0 from "./pretopup.vue?vue&type=style&index=0&id=225562d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225562d3",
  null
  
)

export default component.exports